.footer {
  margin-top: 0;
  border-top: 1px solid var(--gz-line);
  padding: 2rem 0;
  font-size: 0.85rem;
  color: var(--zen-text-muted);
}

.inner {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: space-between;
  max-width: 1120px;
  margin-inline: auto;
  padding-inline: 1.25rem;

  a { color: var(--zen-text-muted); text-decoration: none; &:hover { color: var(--gz-fg); } }
}
